import React, { useState, useEffect } from "react";
import { Modal, Skeleton, Col, Row, Typography } from "antd";
import styles from "assets/css/modals.module.css";

const ViewMedia = props => {
  const { isVisible, handleCancel, fileurl, getUploadedDocument } = props;
  const [loading, setLoading] = useState(true);
  const [filedata, setFiledata] = useState(null);
  const [filename, setFilename] = useState(null);

  useEffect(() => {
    if (fileurl && fileurl?.includes("/mms-temp/")) setFilename(fileurl.split("/mms-temp/")[1]);
    else setFilename(fileurl);
  }, [fileurl]);

  useEffect(() => {
    if (fileurl && fileurl?.includes("/mms-temp/") && filename && isVisible) {
      setLoading(true);
      getUploadedDocument(filename)
        .then(res => {
          if (res.status) {
            setFiledata(res.data);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      setFiledata(fileurl);
    }
    if (!isVisible) setFiledata(null);
  }, [filename, isVisible]);

  const isAudio = contentType => {
    return contentType && contentType.startsWith("audio/");
  };

  const isVideo = contentType => {
    return contentType && contentType.startsWith("video/");
  };

  const isImage = contentType => {
    return contentType && contentType.startsWith("image/");
  };

  if (!fileurl) return null;

  return (
    <>
      <Modal
        destroyOnClose
        centered
        title={
          <div className="text-center">
            <h4 className="pt-3 fw-bold">Media Preview</h4>
          </div>
        }
        closeIcon={
          <div className={`btn ${styles.modalCloseBtn}`}>
            <i className="fas fa-times"></i>
          </div>
        }
        visible={isVisible}
        onCancel={handleCancel}
        width={500}
        footer={null}
        maskStyle={{
          background: "linear-gradient(135deg, #00000050, #107c9850)"
        }}
        zIndex={1031}
      >
        <Row gutter={[20, 20]} type="flex" justify="center">
          <Col span={20} className="text-center">
            {loading ? (
              <Skeleton active />
            ) : (
              <>
                {fileurl && !fileurl.includes("/mms-temp/") && <img src={fileurl} style={{ width: "100%", height: "auto" }} alt="Media" />}
                {fileurl && fileurl.includes("/mms-temp/") && (
                  <>
                    {filedata ? (
                      <>
                        {isAudio(filedata.contentType) && (
                          <audio controls style={{ width: "100%" }} preload="metadata">
                            <source src={`data:${filedata.contentType};base64,${filedata.fileString}`} type={filedata.contentType} />
                            Your browser does not support the audio element.
                          </audio>
                        )}

                        {isVideo(filedata.contentType) && (
                          <video controls style={{ width: "100%", height: "auto" }} preload="metadata">
                            <source src={`data:${filedata.contentType};base64,${filedata.fileString}`} type={filedata.contentType} />
                            Your browser does not support the video element.
                          </video>
                        )}

                        {isImage(filedata.contentType) && <img src={`data:${filedata.contentType};base64,${filedata.fileString}`} style={{ width: "100%", height: "auto" }} alt="Document" />}

                        {!isAudio(filedata.contentType) && !isVideo(filedata.contentType) && !isImage(filedata.contentType) && (
                          <div style={{ textAlign: "center", padding: "20px" }}>
                            <p>File type: {filedata.contentType}</p>
                            <p>This file type cannot be previewed directly.</p>
                            <a href={`data:${filedata.contentType};base64,${filedata.fileString}`} download={filename} style={{ color: "#1890ff", textDecoration: "underline" }}>
                              Download File
                            </a>
                          </div>
                        )}
                      </>
                    ) : (
                      "No Document Found"
                    )}
                  </>
                )}
              </>
            )}
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ViewMedia;
